/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["tr"] = {
    wikiLinkLabel:  "Tartış"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/tr/timeline.js
// module id = 594
// module chunks = 3